// extracted by mini-css-extract-plugin
export default {"onDemand":"OnDemand_onDemand__76hxh","button":"OnDemand_button__wRBWB"};